import VideoConference from "video-conference";
import VoximplantVideoManager from "./Providers/Voximplant/VideoManager";
import AgoraVideoManager from "./Providers/Agora/VideoManager";

/**
 * Управление видеоконференцией
 */
export default class VideoManager {
    private videoProvider: VideoConference.VideoManagerInterface = new AgoraVideoManager();

    /**
     * Изменить провайдера данных
     * @param provider
     */
    public changeProvider(provider: string): void
    {
        if (provider === 'voximplant' && !(this.videoProvider instanceof VoximplantVideoManager)) {
            this.videoProvider = new VoximplantVideoManager();
        }

        if (provider === 'agora' && !(this.videoProvider instanceof AgoraVideoManager)) {
            this.videoProvider = new AgoraVideoManager();
        }
    }

    public getProvider(): VideoConference.VideoManagerInterface
    {
        return this.videoProvider;
    }

    public isAgora(): boolean
    {
        return this.videoProvider instanceof AgoraVideoManager;
    }

    /**
     *  Подключиться к видео-серверу
     */
    public async init(user: string): Promise<void>
    {
        await this.videoProvider.init(user);
    }

    /**
     * Отключиться от видео-сервера
     */
    public async disconnect(): Promise<void>
    {
        await this.videoProvider.disconnect();
    }

    /**
     * Поключиться к комнате
     * @param roomId
     * @param playerId
     */
    public connectToConf(roomId: string, playerId: string): void
    {
        this.videoProvider.connectToConf(roomId, playerId);
    }

    /**
     * Изменить состояние камеры
     */
    public async cameraToggle(cameraStatus: boolean): Promise<void>
    {
        await this.videoProvider.cameraToggle(cameraStatus);
    }

    /**
     * Изменить состояние микрофона
     */
    public async microphoneToggle(micStatus: boolean): Promise<void>
    {
        await this.videoProvider.microphoneToggle(micStatus);
    }

    /**
     * Изменить состояние аудио
     */
    public audioToggle(status: boolean): void
    {
        this.videoProvider.audioToggle(status);
    }

    /**
     * Получение логов
     */
    public getLogs(): Array<string>
    {
        return this.videoProvider.getLogs();
    }

    /**
     * Проверка браузера
     */
    public checkBrowser(): boolean
    {
        return this.videoProvider.checkBrowser();
    }

    public render(videoHolders: Array<HTMLElement>): void
    {
        this.videoProvider.render(videoHolders);
    }

    public closeSettings(): void
    {
        this.videoProvider.closeSettings();
    }
}
